import React from "react";
import styled, { keyframes } from "styled-components";

interface IProps {
  width?: string;
  color?: string;
}
const Spinner = ({ width = "2.4rem" }: IProps) => {
  return <Loader width={width}></Loader>;
};

export default Spinner;

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Define the Loader styled component
const Loader = styled.div<IProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.width};
  border: 2px solid ${(props) => (props.color ? props.color : "#fff")};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotation} 1s linear infinite;
`;
